import { PulseWindow } from '@pulse/browser-shared';

const win: PulseWindow = window as any;
const pi = win.pulseInit || [];
const pr = win.pulseReady || [];
win.pulseInit = pi;
win.pulseReady = pr;
const originalInitPush = pi.push.bind(pi);
const originalReadyPush = pr.push.bind(pr);

function patchedPush(
    ...items: {
        sdk: 'settings' | 'tracker';
        onReady: () => void;
    }[]
) {
    for (const listener of items) {
        if (win.pulse?.tracker || win.pulse?.settingsFactory) {
            listener.onReady();
            continue;
        }

        originalInitPush(listener);
        originalReadyPush(listener);
    }

    return pi.length;
}

pi.push = patchedPush;
pr.push = patchedPush;

export function fireOnLegacyReady(sdk?: string, err?: any) {
    if (err) {
        console.warn(err, sdk);

        return;
    }

    const listeners = pi;
    const readyListeners = pr;

    for (const listener of listeners) {
        pi.splice(pi.indexOf(listener), 1);
        listener.onReady();
    }

    for (const listener of readyListeners) {
        pr.splice(pr.indexOf(listener), 1);
        listener.onReady();
    }
}
